import { apiWeeklyPlanner } from '~constants/api';

import { put } from '~libs/genericAction';
import { createThunks } from '~libs/reduxUtils';

export const typePrefix = 'weekly-planner-unsaved';

const config = [{ actionType: 'simulate', apiPath: `${apiWeeklyPlanner}/simulate`, method: put }];

export const { simulate } = createThunks(typePrefix, config);
